import { api_configuration } from "../common";
import application_api = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.application.alan_api;

function orderAttribute(attribute: application_api.Cattributes): application_api.Cattributes[] {
	switch (attribute.properties.has_successor.state.name) {
		case "no": {
			return [attribute];
		}
		case "yes": {
			const $ = attribute.properties.has_successor.state.node;
			return [attribute].concat(orderAttribute($.properties.attribute.ref));
		}
		default:
			unexpectedState(attribute.properties.has_successor.state);
	}
}

export function orderedAttributes(node: application_api.Cnode__application): application_api.Cattributes[] {
	switch (node.properties.has_attributes.state.name) {
		case "no": {
			return [];
		}
		case "yes": {
			const $ = node.properties.has_attributes.state.node;
			return orderAttribute($.properties.first.ref);
		}
		default:
			unexpectedState(node.properties.has_attributes.state);
	}
}
